import { render, staticRenderFns } from "./ResourceCategoryEdit.vue?vue&type=template&id=44711ad1&"
import script from "./ResourceCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./ResourceCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports